import { useInView } from '@/hooks/useInView';

const formats = [
  { img: 'https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/combination/combination.svg', label: 'Nanit Inclusive Kit', desc: 'Physical robot kit with 12 sensors and 30+ transformation modes' },
  { img: 'https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/combination/combination-2.svg', label: 'Educational Animated Lessons', desc: '30 animated video lessons designed for inclusive learning' },
  { img: 'https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/combination/combination-3.svg', label: 'Expert-Designed Methodology', desc: 'Curriculum developed by special education and STEM experts' },
];

export default function LearningFormat() {
  const { ref, inView } = useInView();

  return (
    <section id="how" ref={ref as React.RefObject<HTMLElement>} className="bg-gray-50 py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className={`text-center mb-14 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">Learning Format</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne">
            Learning format with Nanit Inclusive
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {formats.map((f, i) => (
            <div
              key={f.label}
              className={`bg-white rounded-2xl p-8 flex flex-col items-center text-center gap-5 border border-gray-100 hover:border-yellow-300 transition-all duration-500 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="w-24 h-24 flex items-center justify-center bg-yellow-50 rounded-2xl">
                <img src={f.img} alt={f.label} className="w-16 h-16 object-contain" />
              </div>
              <div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{f.label}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
